import styled from '@emotion/styled';

const SubmenuContentWrapper = styled('section')({
  padding: '10px 16px',
});

export default SubmenuContentWrapper;
